import React from "react";
import { Link } from "react-router-dom";
import CTABanner from "../components/CTABanner";
import LegalSignoff from "../components/LegalSignoff";

const Section = ({ heading, children }) => (
  <div className="mt-10">
    {heading && <h2 className="ek-heading text-2xl md:text-3xl text-black mb-4">{heading}</h2>}
    <div className="ek-body space-y-4 text-[16.5px]">{children}</div>
  </div>
);

const Terms = () => {
  return (
    <>
      <section className="ek-gradient-dark text-white relative overflow-hidden">
        <div className="ek-star-watermark" />
        <div className="ek-container relative z-10 py-20 md:py-28">
          <div className="ek-eyebrow text-[#A179FA]">Legal</div>
          <h1 className="ek-heading text-4xl md:text-5xl lg:text-6xl text-white mt-4 max-w-4xl leading-tight" data-testid="terms-headline">
            Terms of Use
          </h1>
          <p className="text-zinc-200 font-light text-lg mt-6 max-w-3xl">
            The terms governing your use of the Ekselens Consulting website and any associated materials.
          </p>
        </div>
      </section>

      <section className="bg-white py-16 md:py-20">
        <div className="ek-container max-w-4xl">
          <p className="ek-body text-lg">
            These terms govern your use of <strong>www.ekselens.com</strong> and any related materials made available by Ekselens Consulting ("we", "us", "our"). By accessing or using the site, you agree to be bound by these terms. If you do not agree, please do not use the site.
          </p>

          <Section heading="1. About us">
            <p>
              Ekselens Consulting is the trading name of <strong>Ekselens Limited</strong>, a company registered in England &amp; Wales (company no. 15750277), with its registered office at <strong>27 Mortimer Street, London, W1T 3BL, United Kingdom</strong>. You can contact us at <a href="mailto:info@ekselens.com" className="text-[#7737F6] hover:underline">info@ekselens.com</a> or +44 (0) 20 7874 7217.
            </p>
          </Section>

          <Section heading="2. Use of the site">
            <p>You agree to use the site only for lawful purposes and in a way that does not:</p>
            <ul className="list-disc list-inside space-y-2 ml-2">
              <li>Breach any applicable law or regulation;</li>
              <li>Infringe the rights of, restrict or inhibit any other person's use of the site;</li>
              <li>Attempt to gain unauthorised access to any part of the site, its servers or related infrastructure;</li>
              <li>Introduce viruses, trojans, worms or other malicious code.</li>
            </ul>
            <p>
              We reserve the right to suspend or terminate your access to the site at our discretion if these terms are breached.
            </p>
          </Section>

          <Section heading="3. Intellectual property">
            <p>
              All content on the site — including text, graphics, logos, the Ekselens star motif, EKSELENS360 framework, service descriptions, insights articles, dashboards and templates — is the intellectual property of Ekselens Consulting or its licensors, and is protected by copyright and other applicable laws.
            </p>
            <p>
              You may view and download content for your personal, non-commercial reference. Any other use, including reproduction, modification, distribution or republication, requires our prior written consent.
            </p>
          </Section>

          <Section heading="4. Engagement scope">
            <p>
              Information on the site is provided for general information about our services. Nothing on the site constitutes a contractual offer or professional advice. Any engagement with Ekselens Consulting will be governed by a separate written agreement covering scope, deliverables, fees, confidentiality, intellectual property and liability.
            </p>
          </Section>

          <Section heading="5. No warranties">
            <p>
              The site is provided "as is". While we take reasonable care to ensure the content is accurate and up to date, we do not warrant that the site will be uninterrupted, error-free or free of harmful components. To the fullest extent permitted by law, we disclaim all warranties, express or implied.
            </p>
          </Section>

          <Section heading="6. Limitation of liability">
            <p>
              Nothing in these terms limits or excludes our liability for death or personal injury caused by our negligence, fraud, or any other liability that cannot be limited or excluded under English law.
            </p>
            <p>
              Subject to the above, we will not be liable for any indirect, incidental, consequential or special losses arising from your use of the site or reliance on its content.
            </p>
          </Section>

          <Section heading="7. Third-party links">
            <p>
              The site may contain links to third-party websites. We are not responsible for the content, accuracy or practices of those sites, and inclusion of a link does not imply endorsement.
            </p>
          </Section>

          <Section heading="8. Privacy and cookies">
            <p>
              Use of the site is also governed by our <Link to="/privacy" className="text-[#7737F6] hover:underline">Privacy Policy</Link> and <Link to="/cookies" className="text-[#7737F6] hover:underline">Cookie Policy</Link>.
            </p>
          </Section>

          <Section heading="9. Governing law">
            <p>
              These terms are governed by the laws of England and Wales. Any disputes arising from these terms or your use of the site will be subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>
          </Section>

          <Section heading="10. Changes to these terms">
            <p>
              We may update these terms from time to time. The latest version will always be available on this page with a revised date. Continued use of the site after changes constitutes acceptance of the updated terms.
            </p>
          </Section>

          <LegalSignoff page="terms" />
        </div>
      </section>

      <CTABanner />
    </>
  );
};

export default Terms;
